// Check if the relocation date for this AFR is after 1st July 2023
export const isRelocationDateAfterNewChanges = (requiredRelocationDate) => {
    if (requiredRelocationDate === null || requiredRelocationDate === undefined || requiredRelocationDate === '') return true
  
    // New PACMAN categorisation changes on date 1st July 2023
    const newFeatureIntroductionDate = new Date(2023, 6, 1);
  
    const relocationDate = new Date(requiredRelocationDate)
  
    return relocationDate >= newFeatureIntroductionDate;
  }

export const convertToSentenceCase = (textToConvert) => {
    if (textToConvert === undefined || textToConvert === null || textToConvert === '')
        return textToConvert

    return textToConvert.charAt(0).toUpperCase() + textToConvert.slice(1).toLowerCase();    
}
